import { PACKAGE_STORAGE, SELECTED_FLIGHTS_STORAGE } from '@config/storageKeys';
import { IFormValues } from '@interfaces/buildPackage';
import { getEffectivePassengerCount } from '@v2/views/checkout/components/CheckoutForm/utils';
import { PreBookingPayload } from '@v2/views/flights/components/FlightsContent/FlightDrawer/FlightFares';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import useEventLoader from './use-event-loader';
import useMinimumPrice from './useMinimumPrice';
import useStorage from './useStorage';

type PackageDataType = IFormValues | null;

export function useBuildPackageBundle() {
  const storage = useStorage();

  const [packageGuests, setPackageGuests] = useState<number>(0);

  const [currentPackageData] = useState<PackageDataType>(
    JSON.parse(storage.getItem(PACKAGE_STORAGE) ?? '{}')
  );

  const [flightData] = useState<PreBookingPayload | null>(() => {
    const storedData = storage.getItem(SELECTED_FLIGHTS_STORAGE);
    return storedData ? JSON.parse(storedData) : null;
  });

  const isBundle = currentPackageData?.selected?.tickets;

  const searchParams = useSearchParams();
  const eventId = searchParams?.get('eventId');
  const { loading, tickets } = useEventLoader(eventId, isBundle);

  const { ticketPrice } = useMinimumPrice(
    [],
    tickets,
    currentPackageData?.tickets
  );

  useEffect(() => {
    const effectivePassengerCount = getEffectivePassengerCount(
      currentPackageData,
      flightData
    );
    setPackageGuests(effectivePassengerCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPackageData, flightData]);

  return {
    isBundle,
    packageGuests,
    packageData: currentPackageData,
    minTicketPrice: ticketPrice,
  };
}
